import { render } from "./ScDataTableItem.vue?vue&type=template&id=7baef0a7"
import script from "./ScDataTableItem.vue?vue&type=script&lang=js"
export * from "./ScDataTableItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataTable2/ScDataTableItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7baef0a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7baef0a7', __exports__)) {
    console.log('reload')
    api.reload('7baef0a7', __exports__)
  }
  
  module.hot.accept("./ScDataTableItem.vue?vue&type=template&id=7baef0a7", () => {
    console.log('re-render')
    api.rerender('7baef0a7', render)
  })

}


export default __exports__